import { render, staticRenderFns } from "./SentCommunicationOverview.vue?vue&type=template&id=0a803d88&scoped=true"
import script from "./SentCommunicationOverview.vue?vue&type=script&lang=js"
export * from "./SentCommunicationOverview.vue?vue&type=script&lang=js"
import style0 from "./SentCommunicationOverview.vue?vue&type=style&index=0&id=0a803d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a803d88",
  null
  
)

export default component.exports